module.exports = __webpack_public_path__ + "static/media/exhibition-hall.c063c84c.jpg";